import Recaptcha from '../../Layout/Recaptcha';
import SubmitButton from '../../FormElements/SubmitButton';
import FormField from '../../FormElements/Field';
import { useLoginForm } from './useLoginForm';
import * as React from 'react';
import { useForm } from 'react-hook-form';

type LoginFormProps = {
  isAccountant?: boolean;
  emailLabel: string;
};

export interface LoginFormInput {
  email: string;
}

export default function LoginForm({ isAccountant, emailLabel }: LoginFormProps) {
  const { register, handleSubmit, reset } = useForm();
  const { onSubmit, recaptcha, setRecaptcha, recaptchaRef, inProgress } = useLoginForm(isAccountant, register, reset);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField name="email" label={emailLabel}>
          <input
            id="email"
            type="email"
            data-testid={'emailInput'}
            required
            className="form-control"
            {...register('email', {
              required: true,
            })}
          />
        </FormField>
        <Recaptcha recaptcha={recaptcha} setRecaptcha={setRecaptcha} recaptchaRef={recaptchaRef} />
        <SubmitButton
          className="btn rounded-0 box-shadow-btn bg-primary text-uppercase text-nowrap px-4 py-2 fs-5 text-white fw-bold"
          text="Belépek"
          inProgress={inProgress}
          disabled={inProgress}
        />
      </form>
    </>
  );
}
